/* tslint:disable:no-any */
import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements ErrorHandler {
  constructor() {
    if (environment.sentryErrorHandlerDsn) {
      import('@sentry/browser').then(Sentry => {
        Sentry.init({
          dsn: environment.sentryErrorHandlerDsn,
          sampleRate: 0.5,
        });
      });
    }
  }

  handleError(error: any): void {
    error = error.originalError || error;

    // Suppress NG0100 (ExpressionChangedAfterItHasBeenCheckedError) — this is a dev-mode-only
    // verification error that doesn't affect UX or production builds. After the Angular 22
    // upgrade many legacy patterns in this codebase (ReplaySubject services emitting during
    // route mount, ngOnInit mutations of AppComponent state via SideAndTopBarService, etc.)
    // trigger it. See project_angular22_upgrade memory for what we tried.
    if (error?.code === -100 || /NG0100/.test(error?.message ?? '')) {
      return;
    }

    console.error(error);

    this.handleErrorWithSentry(error);
  }

  handleErrorWithSentry(error: any): void {
    if (!environment.sentryErrorHandlerDsn) {
      return;
    }
    import('@sentry/browser').then(Sentry => {
      Sentry.captureException(error);
    });
  }
}
